import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'

export const Toast = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    width: fit-content;
  }

  &&& .Toastify__toast {
    background: #FFF !important;
    border: 1px solid #3D6666;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
    border-radius: 0;
    border-left: 4px solid #3D6666;
    width: fit-content;
  }

  &&&& .Toastify__toast--error {
    border: 1px solid #E84242;
    border-left: 4px solid #E84242;

    aside {
      color: #E84242;
    }

    header {
      color: #E84242;
    }
  }

  &&& .Toastify__close-button > svg {
    color: #0F172A;
    width: 20px;
    height: 20px;
  }

  &&& .Toastify__toast-icon {
    display: none;
  }

  &&& .Toastify__close-button {
    opacity: 1;
    padding: 6px 0 0 20px;
  }

  & .tlie-toast-body-container {
    display: flex;
    gap: 8px;

    aside {
      color: #3D6666;
      padding-top: 2px;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    header {
      color: #3D6666;
      white-space: nowrap;
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
    }

    section {
      color: #7B7C82;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      white-space: nowrap;
      margin-top: 3px;
    }

    a {
      color: #3D6666;
      margin-right 10px;
      font-size: 16px;
    }

    a:hover {
      text-decoration: underline;
    }
  }
`